import { render } from "./odometer.vue?vue&type=template&id=d665ff00&scoped=true"
import script from "./odometer.vue?vue&type=script&lang=js"
export * from "./odometer.vue?vue&type=script&lang=js"

import "./odometer.vue?vue&type=style&index=0&id=d665ff00&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d665ff00"

export default script